/* @flow */
import React from 'react';
import THead from 'components/UIKit/Table/THead';
import Tr from 'components/UIKit/Table/Tr';
import Th from 'components/UIKit/Table/Th';
import Td from 'components/UIKit/Table/Td';

export default function UploadTransactionsColumns(): React.Element {
  return (
    <THead>
      <Tr>
        <Th style={{paddingLeft: '2.8rem'}}>ID</Th>
        <Th>Step</Th>
        <Th>DateTime</Th>
        <Th>User</Th>
        <Th>State</Th>
        <Td />
      </Tr>
    </THead>
  );
}
